<template>
  <!-- Terms And Conditions -->
  <div class="flex flex-row my-5 relative z-50">
    <div class="md:w-full" v-if="authStore.getLandingPageLanguage == 'en'">
      <h1 class="text-white font-bold mb-1 text-[14px]">Terms & Conditions</h1>

      <p class="text-white mb-0 mx-1.5 text-[13px] ">
        By clicking on the above subscribe button, you will agree on the below
        terms and conditions:
      </p>

      <ul class="list-disc text-white sm:text-md text-[12px]">
        <li class="list-inside mx-2 term-color">
          No commitment, You can cancel your subscription at any time by sending
          <strong class="font-bold">C NAS</strong> to 1111
        </li>
        <li class="list-inside mx-2 font-extralight">
          You will start the paid subscription after the free period
          automatically
        </li>
        
        <li class="list-inside mx-2 font-extralight">
          To get support, please contact
          <a href = "mailto: info@ae.nasna.tv"> <span class="font-bold underline text-color">info@ae.nasna.tv</span> </a> or
          <a href="tel:+971566083036">
            <span class="font-bold text-color">+971566083036</span></a
          >
        </li>
        <li class="list-inside mx-2 font-extralight ">
          The free trail is valid only for new subscribers
        </li>
        <li class="list-inside mx-2 font-extralight ">
          Enjoy Your Free trial for 24 hours
        </li>
        <li class="list-inside mx-2 font-extralight ">
          Please make sure that your browser is not using any 3rd party blocking
          technologies and you have a healthy internet connection for swift
          access to the content.
        </li>
        <li class="list-inside mx-2 font-extralight absolute z-50">
          For full terms and conditions
          <strong
            ><router-link to="/show/terms" class="text-color font-bold text-md"
              >click here</router-link
            ></strong
          >
        </li>
      </ul>
    </div>

    <div
      class="md:w-full"
      v-if="authStore.getLandingPageLanguage == 'ar'"
      dir="rtl"
    >
      <h1 class="text-white font-bold mb-1 text-[14px]">الأحكام والشروط</h1>

      <p class="text-white mb-0 mr-1 text-[13px] ">
        بالضغط على زر الاشتراك أعلاه ، فإنك توافق على الشروط والأحكام التالية:
      </p>

      <ul class="list-disc text-white sm:text-md text-[12px]">
        <li class="list-inside mx-1 term-color">
          لا يوجد التزام ، يمكنك إلغاء اشتراكك في أي وقت عن طريق 
        إرسال
          <strong class="font-bold">C NAS</strong> إلى 1111
        </li>
        <li class="list-inside mx-1 font-extralight">
          يبدأ الاشتراك المدفوع تلقائيًا بعد الفترة المجانية
        </li>
       
        <li class="list-inside mx-1 font-extralight">
          للحصول على الدعم الفني ، يرجى التواصل مع <a href = "mailto: info@ae.nasna.tv"> <span class="font-bold underline text-color">info@ae.nasna.tv</span> </a> أو 
         
          <a href="tel:+971566083036"> <span class="font-bold text-color">971566083036+</span></a>
        </li>
        <li class="list-inside mx-1 font-extralight ">
          التجربة المجانية صالحة فقط للمشتركين الجدد
        </li>
        <li class="list-inside mx-1 font-extralight ">
          استمتع بتجربتك المجانية لمدة 24 ساعة
        </li>
        <li class="list-inside mx-1 font-extralight ">
          يرجى التأكد من أن متصفحك لا يستخدم أي تقنيات حظر تابعة لجهات خارجية
          وأن لديك اتصال إنترنت جيد للوصول السريع إلى المحتوى.
        </li>
        <li class="list-inside mx-2 font-extralight absolute z-50">
          للشروط والأحكام الكاملة
          <strong>
            <router-link to="/show/terms" class="text-color"
              >اضغط هنا</router-link
            ></strong
          >
        </li>
      </ul>
    </div>
  </div>
  <!-- End Of Terms And Conditions -->
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
};
</script>

<style>
.term-color {
  color: #9d2890;
}
</style>
